import useTranslationText from 'Hooks/useTranslationText'
import React from 'react'

const AccessDeniedPage = () => {

    const [translation] = useTranslationText()

    return (
        <div className="content-inner">
            <div className="d-flex flex-column flex-lg-row justify-content-between p-3">
                <div className="title text-dark mb-3 mb-lg-0"> </div>
            </div>
            <div className="bg-white rounded shadow-sm h-100">
                <h2 className='text-center'>{translation('ACCESS_DENIED_PAGE')}</h2>
            </div>
        </div>
    )
}

export default AccessDeniedPage